<style scoped lang="less">
.avatar{
  overflow: hidden;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  &-0{
    color:#2A89F4;
    background: rgba(42, 137, 244, 0.15);
  }
  &-1{
    color:#FF5000;
    background: rgba(255, 80, 0, 0.15);
  }
  &-2{
    color:#673AE2;
    background: rgba(103, 58, 226, 0.15);
  }
  &-3{
    color: #FF2442;
    background: rgba(255, 36, 66, 0.15);
  }
  &__text{
    font-size: 18px;
    font-weight: 500;
  }
  &__img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
  &__text{
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
  }
}
</style>
<template>
  <div class="avatar">
    <img :style="$props.styleText" :src="$props.src" alt="头像" class="avatar__img" v-if="$props.src">
    <div :style="$props.styleText" class="avatar__text" :class="getStyles()" v-else-if="showText">{{findFirstChineseCharacter || showText}}</div>
    <img :style="$props.styleText" :src="$defaultSrc" alt="头像" class="avatar__img" v-else>
  </div>
</template>
<script>
export default {
  name: "Avatar",
  components: {},
  props: {
    text: { type:String },
    src: { type:String },
    styleText:{ type:String }
  },
  computed: {
    showText:(_this = this) => _this.$props.text?.slice(0,1),
    findFirstChineseCharacter() {
      const regex = /[\u4e00-\u9fff]/;  // 匹配汉字的正则表达式
      const match = this.text.match(regex);  // 在字符串中寻找匹配项

    if (match) {
        return match[0];  // 如果有匹配到，返回第一个匹配项
    } else {
        return '';  // 如果没有匹配到，返回空字符串
    }
   },
  },
  methods:{

    getStyles(){
      const num = (Math.random() * 3).toFixed(0)
      return `avatar-${num}`
    }
  },
}
</script>
